import type { Capabilities } from '@rtkwlf/rendall';
import { Navigate } from 'react-router-dom';

import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import i18n from './locales/i18n';

const unifiedContentLibraryCapability: Partial<Capabilities> = {
  detectionLibrary: true,
};

export default {
  routes: [
    {
      path: 'unified-content-library',
      element: (
        <LegacyCapabilitiesGuard
          capabilities={unifiedContentLibraryCapability}
        />
      ),
      children: [
        {
          index: true,
          element: <Navigate to="search" replace />,
        },
        {
          path: 'search',
          lazy: () => import('./pages/catalog-search/catalog-search.page'),
        },
        {
          path: 'detections',
          lazy: () => import('./pages/detection-detail/detection-detail.page'),
        },
      ],
    },
  ],
  navigation: ({ legacyCapabilities }) => {
    const hasRiskCatalogAccess =
      legacyCapabilities &&
      hasAnyRequiredProperty(
        unifiedContentLibraryCapability,
        legacyCapabilities,
      );

    if (!hasRiskCatalogAccess) return {};

    return {
      riskManagement: {
        riskCatalog: {
          title: i18n.t('unifiedContentLibrary:riskCatalog'),
          segment: '/unified-content-library',
        },
      },
    };
  },
} satisfies FeatureConfig;
